import { useEffect } from 'react';
import {
    FormControl,
    Grid2 as Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CommonCard } from '../../component/cards/MainCard2';
import { SubmitButton } from '../../component/buttons';

import PersonalBodyCard from '../pages/UsersAdd/body/PersonalBodyCard';
import HeaderCard from '../pages/UsersAdd/HeaderUserAdd';
import { useClinics } from '../../hooks/useClinics';
import ManagementHeader from './componets/ManagementHeader';
import { useFormikAddUser } from 'hooks/useFormikAddUser';

const CreateClinicUser = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { state } = useLocation();

    const clinic = state?.clinic;
    const preselectedRole = state?.preselectedRole;

    const roleToTypeValue = {
        PATIENT: 0,
        DOCTOR: 1,
        CLINIC_ADMIN: 2,
        CLINIC_CARE_GIVER: 3,
        PATIENT_CARE_GIVER: 4
    };

    const { data: clinics = [], isLoading } = useClinics();

    const preselectedType = preselectedRole ? roleToTypeValue[preselectedRole] : 2;

    const formik = useFormikAddUser(preselectedType, {
        redirectTo: '/mgmt/clinic/users',
        redirectState: clinic ? { clinic } : undefined
    });

    useEffect(() => {
        if (clinic) {
            formik.setFieldValue('clinic_id', clinic.uuid);
        }
    }, [clinic]);

    const handleCancel = () => {
        navigate('/mgmt/clinic/users', {
            state: { clinic }
        });
    };

    return (
        <CommonCard sx={{ m: 2, p: 2 }}>
            <ManagementHeader
                title={t('users.addNewUser')}
                subtitle={clinic?.name || t('clinics.selectClinic')}
                backTo={clinic ? '/mgmt/clinic/users' : '/mgmt/clinics'}
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    {!clinic && (
                        <Grid size={12}>
                            <FormControl fullWidth required>
                                <InputLabel id="clinic-select-label">
                                    {t('clinics.clinic')}
                                </InputLabel>
                                <Select
                                    labelId="clinic-select-label"
                                    label={t('clinics.clinic')}
                                    value={formik.values.clinic_id || ''}
                                    onChange={(e) =>
                                        formik.setFieldValue('clinic_id', e.target.value)
                                    }
                                >
                                    {isLoading ? (
                                        <MenuItem disabled>
                                            {t('common.loading')}
                                        </MenuItem>
                                    ) : (
                                        clinics.map((c) => (
                                            <MenuItem key={c.uuid} value={c.uuid}>
                                                {c.name}
                                            </MenuItem>
                                        ))
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {/* Header */}
                    <Grid size={12}>
                        <HeaderCard
                            values={formik.values}
                            handleChange={formik.handleChange}
                            disableClinicSelect={!!clinic}
                        />
                    </Grid>

                    {/* Personal data only */}
                    <Grid size={12}>
                        <Typography variant="h6" gutterBottom>
                            {t('users.tabs.personalData')}
                        </Typography>

                        <PersonalBodyCard formik={formik} />
                    </Grid>

                    {/* Actions */}
                    <Grid
                        container
                        size={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                            mt: 2
                        }}
                    >
                        <SubmitButton type="button" onClick={handleCancel}>
                            {t('common.cancel')}
                        </SubmitButton>

                        <SubmitButton
                            disabled={formik.isSubmitting || !formik.values.clinic_id}
                            name="submit"
                            type="submit"
                        >
                            {t('common.save')}
                        </SubmitButton>
                    </Grid>
                </Grid>
            </form>
        </CommonCard>
    );
};

export default CreateClinicUser;
